import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { getSelectedStore, getCategoryList } from 'x/redux/selectors'
import * as StoreState from 'x/modules/store/StoreState'
import * as CategoryActions from 'x/modules/category/categoryState'

import { categoryByStore, ICategory, IProductCategorySelectorProps, IProductCategorySelectorState } from 'x/types'
import * as util from 'x/utils/util'

import _ from 'lodash'
import { List } from 'immutable'
import { TouchableOpacity } from 'react-native'
import { COLORS } from 'x/config/styles'
import VStack from '../VStack'
import XHorizontalScrollView from '../XHorizontalScrollView'
import XText from '../XText'
import HStack from '../HStack'
import XIcon from '../XIcon'

class ProductCategorySelector extends Component<IProductCategorySelectorProps, IProductCategorySelectorState> {
  static displayName = 'ProductCategorySelector'

  inProcess?: boolean

  constructor(props) {
    super(props)

    this.state = {
      isInitialized: false,
      categoryList: null,
    }
  }

  async componentDidMount(): Promise<void> {
    await this._setupCategoryList()

    this.setState({ isInitialized: true })
  }

  _setupCategoryList = async () => {
    const { storeId, categoryList = List([]) } = this.props
    const catGroupList = categoryList.toJS()

    const foundIndex = catGroupList.findIndex((catG: categoryByStore) => catG.store_id === storeId)
    if (foundIndex >= 0) {
      const catGroup = catGroupList[foundIndex]

      await util.setStatePromise(this, { categoryList: util.appendNotSpecifiedProductCategoryIfNotExist(catGroup.category) })
      return
    }

    const { requestCategoryList } = this.props

    const res: ICategory[] = await new Promise((resolve) => {
      requestCategoryList({
        body: {
          store_id: storeId,
        },
        successCallback: resolve,
        failedCallback: resolve,
      })
    })

    // console.log('_setupCategoryList res => ', res)

    if (!_.isNil(res) && _.isArray(res)) {
      await util.setStatePromise(this, { categoryList: util.appendNotSpecifiedProductCategoryIfNotExist(res) })
    }
  }

  // _configCategory = async () => {
  //   const { categoryList, requestCategoryList, navigation } = this.props
  //   const { mode, store_id, seller_store_id } = this._getParams()
  //   // console.log('mode => ', mode)
  //   if (mode === MKP_MAPPING) {
  //     return null
  //   }
  //   // const { mode, store_id, seller_store_id } = this._getParams()
  //   let storeId = this.getTargetStoreId()
  //   // const storeId = this.getTargetStoreId()
  //   let CATEGORYS = null
  //   const CettoJS = _.isNil(categoryList) ? [] : categoryList.toJS()
  //   CettoJS.map((data: categoryByStore) => {
  //     if (storeId === data.store_id) {
  //       CATEGORYS = data.category
  //     }
  //   })

  //   if (mode === PULL_PRODUCT) {
  //     storeId = seller_store_id
  //   } else if (mode === PULL_SELLER_PRODUCT_TO_ORDER) {
  //     storeId = seller_store_id
  //   } else if (mode === VIEW_SELLER) {
  //     storeId = seller_store_id
  //   }
  //   if (_.isNil(CATEGORYS) || CATEGORYS.length < 1) {
  //     const res: ICategory[] = await new Promise((resolve) => {
  //       requestCategoryList({
  //         body: {
  //           store_id: storeId,
  //         },
  //         successCallback: resolve,
  //         failedCallback: resolve,
  //       })
  //     })
  //     if (!_.isNil(res) && _.isArray(res)) {
  //       CATEGORYS = res
  //     }
  //   }
  //   const catSeletedCategory = null
  //   const catLevelCategoryList = []
  //   const catSupCategory = []
  //   if (_.isNil(CATEGORYS)) {
  //     CATEGORYS = []
  //   }
  //   const haveUnknownCat = CATEGORYS.find((data: ICategory) => data.id === 0)
  //   if (_.isNil(haveUnknownCat)) {
  //     const unknownCat: ICategory = { id: 0, n: `ไม่ระบุหมวดหมู่`, l: COLORS.TEXT_INACTIVE }
  //     CATEGORYS.push(unknownCat)
  //   }
  //   CATEGORYS.map((data: ICategory) => {
  //     if (_.isNil(data.p)) {
  //       catSupCategory.push(data)
  //       catLevelCategoryList.push(data)
  //     }
  //   })

  //   await util.setStatePromise(this, {
  //     catSeletedCategory,
  //     catLevelCategoryList,
  //     catSupCategory,
  //   })
  // }

  _onPressProductCategory = async (category?: ICategory) => {
    const { onSelectCategory } = this.props

    onSelectCategory(category)
  }

  _renderCatListSelectorItem = (data: ICategory, index: number, categoryList: ICategory[]) => {
    const { selectedCategoryId } = this.props

    if (_.isNil(selectedCategoryId) && data.p) {
      return null
    }

    if (selectedCategoryId && data.p !== selectedCategoryId) {
      return null
    }

    return this._renderCatListItem('Selector', data, index)
    // const marginLeft = index === 0 ? 12 : 12
    // const marginRight = index + 1 === categoryList.length ? 4 : 4
    // const textColor = data.l ? data.l : COLORS.TEXT_INACTIVE
    // return (
    //   <TouchableOpacity
    //     key={`CatListItem_${index}_${data.id}`}
    //     // onPress={() => this._selectedSubCategory(data)}
    //     onPress={() => this._onPressProductCategory(data)}
    //     style={{
    //       // minWidth: 50,
    //       // // width: 50,
    //       // // maxWidth: 120,
    //       // // height: 25,
    //       // borderColor: data.l,
    //       // borderWidth: 0.7,
    //       // borderRadius: 7,
    //       marginLeft,
    //       marginRight,
    //       // paddingLeft: 4,
    //       // paddingRight: 4,
    //       // justifyContent: 'center',
    //     }}>
    //     <Box minW='50px' borderWidth='1' borderRadius='lg' px='2' py='1' alignItems='center' justifyContent='center' borderColor={data.l}>
    //       <XText style={{ color: textColor }}>{data.n}</XText>
    //     </Box>
    //   </TouchableOpacity>
    // )
  }

  _renderCatListItem = (key: string, cat: ICategory, index: number) => {
    const { disabled } = this.props
    const textColor = cat.l && !disabled ? cat.l : COLORS.TEXT_INACTIVE

    return (
      <HStack key={`CatListItem_${key}_${index}_${cat.id}`} pb='0.5' pr='1'>
        <TouchableOpacity disabled={disabled} onPress={() => this._onPressProductCategory(cat)}>
          <HStack
            minW='50px'
            borderWidth='1'
            // borderRadius='lg'
            borderRadius='3xl'
            px='1.5'
            py='0.5'
            alignItems='center'
            justifyContent='center'
            borderColor={disabled ? COLORS.TEXT_INACTIVE : cat.l}
            space='1'
          >
            <XText fontSize='xs' style={{ color: textColor }}>
              {cat.n}
            </XText>
          </HStack>
        </TouchableOpacity>
      </HStack>
    )
  }

  _renderCatListItems = () => {
    const { categoryList } = this.state

    return categoryList.map(this._renderCatListSelectorItem)
  }

  getSelectedCategory = () => {
    const { categoryList } = this.state
    const { selectedCategoryId } = this.props

    if (_.isNil(selectedCategoryId)) {
      return null
    }

    const foundIndex = categoryList.findIndex((cat) => cat.id === selectedCategoryId)
    if (foundIndex === -1) {
      return null
    }

    return categoryList[foundIndex]
  }

  _getSelectedCategoryBreadcrumbName = () => {
    const { categoryList } = this.state
    const selectedCategory = this.getSelectedCategory()

    let selectedCatName = selectedCategory.n

    let focusCatId = selectedCategory.p
    let isMoreParent = _.isNumber(selectedCategory.p)
    while (isMoreParent) {
      const foundCat = categoryList.find((cat: ICategory) => cat.id === focusCatId)
      if (foundCat) {
        selectedCatName = `${foundCat.n} > ${selectedCatName}`
        focusCatId = foundCat.p
        isMoreParent = _.isNumber(foundCat.p)
      } else {
        isMoreParent = false
      }
    }

    return selectedCatName
  }

  _getBreadcrumbCategoryItems = () => {
    const { categoryList } = this.state
    const selectedCategory = this.getSelectedCategory()

    if (!selectedCategory) {
      return null
    }

    let focusCatId = selectedCategory.p
    let isMoreParent = _.isNumber(selectedCategory.p)
    const catItems = [selectedCategory]
    while (isMoreParent) {
      const foundCat = categoryList.find((cat: ICategory) => cat.id === focusCatId)
      if (foundCat) {
        catItems.unshift(foundCat)
        focusCatId = foundCat.p
        isMoreParent = _.isNumber(foundCat.p)
      } else {
        isMoreParent = false
      }
    }

    return catItems
  }

  _renderSelectedBreadcrumbCategoryItems = () => {
    const { categoryList } = this.state
    const selectedCategory = this.getSelectedCategory()

    if (!selectedCategory) {
      return null
    }

    return this._getBreadcrumbCategoryItems().map(this._renderSelectedBreadcrumbCategoryItem)
  }

  _renderSelectedBreadcrumbCategoryItem = (cat: ICategory, index: number) => (
    <HStack key={`CatBreadcrumbItem_${index}_${cat.id}`} space='1' alignItems='center'>
      <XText variant='inactive' bold fontSize='md' textAlign='center' alignSelf='center'>
        /
      </XText>

      {this._renderCatListItem('Breadcrumb', cat, index)}
    </HStack>
  )

  _renderSelectedCategory = () => {
    const selectedCategory = this.getSelectedCategory()

    if (!selectedCategory) {
      return null
    }

    // const textColor = selectedCategory.l ? selectedCategory.l : COLORS.TEXT_INACTIVE
    return (
      <XHorizontalScrollView w='full'>
        <HStack w='full' px='2' py='0.5' space='1' alignItems='center'>
          {/* <XText>เลือกหมวดหมู่: </XText> */}

          <TouchableOpacity onPress={() => this._onPressProductCategory(null)}>
            <HStack pb='1' w='24px' h='24px' borderRadius='7' justifyContent='center' alignItems='center'>
              <XIcon name='home' family='FontAwesome' color='black' />
            </HStack>
          </TouchableOpacity>

          {this._renderSelectedBreadcrumbCategoryItems()}

          {/* <HStack
          minW='50px'
          borderWidth='1'
          borderRadius='lg'
          px='2'
          py='1'
          alignItems='center'
          justifyContent='center'
          borderColor={selectedCategory.l}
          space='1'>
          <XText style={{ color: textColor }}>{this._getSelectedCategoryBreadcrumbName()}</XText>

          <TouchableOpacity onPress={() => this._onPressProductCategory(null)}>
            <XIcon name='close' family='Ionicons' variant='danger' w='24px' h='24px' />
          </TouchableOpacity>
        </HStack> */}
        </HStack>
      </XHorizontalScrollView>
    )
  }

  renderMain = () => {
    const { isSelectorHorizontalScrollDisabled } = this.props
    const { categoryList } = this.state

    if (_.isNil(categoryList) || categoryList.length === 0) {
      return null
    }

    const selectedCategory = this.getSelectedCategory()

    const isSelectorVisible = !selectedCategory || selectedCategory.c.length > 0

    if (isSelectorHorizontalScrollDisabled) {
      return (
        <VStack w='full' style={{ flex: 1 }}>
          {this._renderSelectedCategory()}

          <HStack w='full' pt='0.5' space='1' alignItems='center' flexWrap='warp' style={{ flexWrap: 'wrap' }}>
            {isSelectorVisible && this._renderCatListItems()}
          </HStack>
        </VStack>
      )
    }

    return (
      <VStack w='full' bg='white' px='2' py='0.5'>
        {this._renderSelectedCategory()}

        {isSelectorVisible && (
          <XHorizontalScrollView w='full'>
            <HStack w='full' pt='0.5' space='1' alignItems='center'>
              {this._renderCatListItems()}
            </HStack>
          </XHorizontalScrollView>
        )}
      </VStack>
    )
  }

  render() {
    const { isInitialized } = this.state

    if (!isInitialized) {
      return null
    }

    return this.renderMain()
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
    categoryList: getCategoryList(state),
  }),
  (dispatch) => ({
    dispatch,
    requestCategoryList: bindActionCreators(CategoryActions.requestCategoryList, dispatch),
    updateSelectedStoreByKey: bindActionCreators(StoreState.updateSelectedStoreByKey, dispatch),
  })
)(ProductCategorySelector) as React.FC<
  Omit<IProductCategorySelectorProps, 'selectedStore' | 'updateSelectedStoreByKey' | 'requestCategoryList' | 'categoryList'>
>
